import global from './globalsBase';
import { DEFAULT_API_URL, DEFAULT_LOGIN_API_URL } from '../apiUrls';

global.systemEnvironment = {
    environment: 'live',
    SPROUT_LOGIN_URL: DEFAULT_LOGIN_API_URL,
    SPROUT_BASE_URL: DEFAULT_API_URL
};

export default global;